import { Utils } from "@/lib/utility/utils";
import { MrfiktivHttpClientProvider } from "@/services/mrfiktiv/mrfiktiv-http-client.provider";
import {
  MrfiktivClearanceApprovalViewModelGen,
  MrfiktivCreateRequestStatusHistoryElementDtoGen,
  MrfiktivUpdateClearanceApprovalFileDtoGen
} from "../v1/data-contracts";
import { ClearanceApprovalRequest } from "../v1/ClearanceApprovalRequest"; // Adjusted import
import { HttpClient } from "../v1/http-client";

/**
 * Communicate with ClearanceApprovalRequest API
 */
class ClearanceApprovalRequestService {
  client: HttpClient;
  mrfiktivProxy: ClearanceApprovalRequest;

  /**
   * Construct service
   */
  constructor(mrfiktivHttpClientProvider: MrfiktivHttpClientProvider) {
    this.client = mrfiktivHttpClientProvider.client();
    this.mrfiktivProxy = new ClearanceApprovalRequest(this.client);
  }

  /**
   *
   * Gets a report by shared access signature
   *
   * @param partnerId
   * @param clearanceApprovalId
   * @param sct
   * @returns
   */
  async getDocumentBySharedAccessToken(
    partnerId: string,
    clearanceApprovalId: string,
    sct: string
  ): Promise<MrfiktivClearanceApprovalViewModelGen> {
    const shared = await this.mrfiktivProxy.clearanceApprovalRequestControllerGet({
      partnerId,
      clearanceApprovalId,
      sct
    });

    return shared.data;
  }
  /**
   *
   * Accepts a clearance approval request with optional file upload
   *
   * @param partnerId
   * @param clearanceApprovalId
   * @param sct
   * @param data
   * @returns
   */
  async respondAccept(
    partnerId: string,
    clearanceApprovalId: string,
    sct: string,
    data: MrfiktivUpdateClearanceApprovalFileDtoGen
  ): Promise<MrfiktivClearanceApprovalViewModelGen> {
    const form = new FormData();
    Utils.buildFormData(form, data);


    return (
      await this.client.instance.patch(
        `/partner/${partnerId}/clearance-approval/${clearanceApprovalId}/request/accept`,
        form,
        { params: { sct } }
      )
    ).data;
  }

  /**
   *
   * Gets a report by shared access signature
   *
   * @param partnerId
   * @param clearanceApprovalId
   * @param sct
   * @param data
   * @returns
   */
  async respondReject(
    partnerId: string,
    clearanceApprovalId: string,
    sct: string,
    data: MrfiktivCreateRequestStatusHistoryElementDtoGen
  ): Promise<MrfiktivClearanceApprovalViewModelGen> {
    const shared = await this.mrfiktivProxy.clearanceApprovalRequestControllerReject(
      { partnerId, clearanceApprovalId, sct },
      data
    );

    return shared.data;
  }
}

/**
 * Communicate with ClearanceApprovalRequest API
 */
export default new ClearanceApprovalRequestService(new MrfiktivHttpClientProvider());
